import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { GoalsAndProgress } from '@interfaces';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialogService: DialogService, areaService: AcceleratorAreaService): GridSetup<GoalsAndProgress> {

	return {
		rowName: { singular: 'Goal', plural: 'Goals' },
		getRowKey: row => '' + row.accGoalId,
		stateKey: 'accelerator-goals-and-progress-grid',
		actions: getActions(dialogService, areaService),
		buttons: getButtons(dialogService, areaService),
		columns: getColumns(util),
	}
}
